import React from 'react';
import { Section, Button, Countdown } from './Shared';
export const Closing = () => {
  return <>
      {/* Cost of Not Having It */}
      <Section bg="dark" data-id="element-10">
        <div className="max-w-4xl mx-auto" data-id="element-11">
          <h2 className="font-playfair text-3xl md:text-5xl font-bold text-center mb-12" data-id="element-12">
            ⚖️ ¿Cuánto te cuesta no tenerlo?
          </h2>

          <div className="bg-[#222] rounded-xl overflow-hidden border border-gray-800 mb-12" data-id="element-13">
            <div className="overflow-x-auto" data-id="element-14">
              <table className="w-full text-left font-montserrat" data-id="element-15">
                <thead data-id="element-16">
                  <tr className="bg-[#111] text-base" data-id="element-17">
                    <th className="p-4 md:p-6 font-bold w-1/2" data-id="element-18">
                      Sin el Megakit
                    </th>
                    <th className="p-4 md:p-6 font-bold w-1/2 border-l border-gray-800 text-accent" data-id="element-19">
                      El costo real
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-800 text-gray-300" data-id="element-20">
                  <tr data-id="element-21">
                    <td className="p-4 md:p-6" data-id="element-22">
                      3 turnos perdidos por mes por WhatsApp
                    </td>
                    <td className="p-4 md:p-6 font-bold text-accent bg-[#1A1A1A] border-l border-gray-800" data-id="element-23">
                      $24.000 por mes que se van
                    </td>
                  </tr>
                  <tr data-id="element-24">
                    <td className="p-4 md:p-6" data-id="element-25">Eso en 12 meses</td>
                    <td className="p-4 md:p-6 font-bold text-accent bg-[#1A1A1A] border-l border-gray-800" data-id="element-26">
                      $288.000 que perdiste este año
                    </td>
                  </tr>
                  <tr data-id="element-27">
                    <td className="p-4 md:p-6" data-id="element-28">Clientas que no vuelven</td>
                    <td className="p-4 md:p-6 font-bold text-accent bg-[#1A1A1A] border-l border-gray-800" data-id="element-29">
                      Siempre buscando nuevas para sobrevivir
                    </td>
                  </tr>
                  <tr data-id="element-30">
                    <td className="p-4 md:p-6" data-id="element-31">
                      Contenido improvisado sin sistema
                    </td>
                    <td className="p-4 md:p-6 font-bold text-accent bg-[#1A1A1A] border-l border-gray-800" data-id="element-32">
                      Semanas enteras sin una sola consulta
                    </td>
                  </tr>
                  <tr data-id="element-33">
                    <td className="p-4 md:p-6" data-id="element-34">
                      Precios que no subís por miedo
                    </td>
                    <td className="p-4 md:p-6 font-bold text-accent bg-[#1A1A1A] border-l border-gray-800" data-id="element-35">
                      Cientos de miles menos al año
                    </td>
                  </tr>
                  <tr data-id="element-36">
                    <td className="p-4 md:p-6" data-id="element-37">
                      Sin protocolo de cancelaciones
                    </td>
                    <td className="p-4 md:p-6 font-bold text-accent bg-[#1A1A1A] border-l border-gray-800" data-id="element-38">
                      Turnos vacíos que te cuestan dinero cada mes
                    </td>
                  </tr>
                  <tr className="bg-brand text-dark" data-id="element-39">
                    <td className="p-4 md:p-6 font-bold" data-id="element-40">El Megakit cuesta</td>
                    <td className="p-4 md:p-6 font-bold border-l border-dark/20 text-xl" data-id="element-41">
                      $19.990 una sola vez
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="text-center font-montserrat text-lg md:text-xl space-y-6" data-id="element-42">
            <p className="font-bold text-brand" data-id="element-43">
              Una sola clienta extra paga el Megakit. Todo lo demás es ganancia
              pura.
            </p>
            <p className="text-gray-300" data-id="element-44">
              Cada semana que pasa sin sistema es una semana de contenido
              improvisado, turnos que se escapan, clientas que no vuelven y
              precios que no subís.
            </p>
            <p className="text-base font-bold" data-id="element-45">
              El próximo lunes puede ser diferente. Pero solo si tomás la
              decisión hoy.
            </p>
          </div>
        </div>
      </Section>

      {/* Final CTA */}
      <Section bg="dark" className="border-t border-gray-800 pt-16 pb-24" data-id="element-46">
        <div className="max-w-3xl mx-auto text-center" data-id="element-47">
          <h2 className="font-playfair text-4xl md:text-6xl font-bold leading-tight mb-10 text-base" data-id="element-48">
            Tu agenda puede estar llena.
            <br data-id="element-49" />
            Tus clientas pueden volver solas.
            <br data-id="element-50" />
            Tu negocio puede ser diferente.
            <br data-id="element-51" />
            <span className="text-brand" data-id="element-52">Desde hoy.</span>
          </h2>

          <div className="mb-10" data-id="element-53">
            <p className="font-montserrat text-lg text-gray-300 mb-4" data-id="element-54">
              ⏰ El precio de lanzamiento cierra pronto.
            </p>
            <div className="inline-block bg-[#222] py-4 px-8 rounded-xl border border-gray-700" data-id="element-55">
              <Countdown className="text-3xl md:text-4xl" data-id="element-56" />
            </div>
          </div>

          <div className="flex flex-col gap-4 max-w-xl mx-auto mb-8" data-id="element-57">
            <Button variant="primary" className="bg-white text-dark hover:bg-gray-100 flex-col py-4" data-id="element-58">
              <span className="text-sm font-bold tracking-widest text-gray-500 mb-1" data-id="element-59">
                💅 MEGAKIT MÁS CLIENTAS
              </span>
              <span className="text-xs font-normal mb-2" data-id="element-60">
                6 Tomos + 4 Bonos
              </span>
              <span className="text-lg mb-2" data-id="element-61">
                <span className="line-through text-gray-400 text-sm mr-2" data-id="element-62">
                  $55.990
                </span>
                $19.990 ARS
              </span>
              <span className="text-base" data-id="element-63">→ QUIERO MI MEGAKIT</span>
            </Button>

            <Button variant="brand" className="flex-col py-5 relative overflow-hidden shadow-[0_0_20px_rgba(201,168,124,0.3)]" data-id="element-64">
              <div className="absolute top-0 left-0 w-full bg-dark text-brand text-[10px] py-1 font-bold tracking-widest" data-id="element-65">
                ⭐ MÁS ELEGIDA
              </div>
              <span className="text-sm font-bold tracking-widest text-dark mt-4 mb-1" data-id="element-66">
                👑 MEGAKIT + DUEÑA PRO
              </span>
              <span className="text-xs font-normal mb-2" data-id="element-67">
                10 Tomos + 4 Bonos
              </span>
              <span className="text-lg mb-2" data-id="element-68">
                <span className="line-through text-dark/50 text-sm mr-2" data-id="element-69">
                  $79.990
                </span>
                $27.990 ARS
              </span>
              <span className="text-base" data-id="element-70">→ QUIERO EL MEGAKIT + DUEÑA PRO</span>
            </Button>
          </div>

          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 font-montserrat text-xs text-gray-400" data-id="element-71">
            <span data-id="element-72">🔒 Pago 100% seguro</span>
            <span data-id="element-73">⚡ Acceso en 5 minutos</span>
            <span data-id="element-74">🛡️ Garantía 7 días</span>
            <span className="w-full md:w-auto" data-id="element-75">
              💳 Mercado Pago · Tarjeta · Transferencia
            </span>
          </div>
        </div>
      </Section>

      {/* Footer */}
      <footer className="bg-[#111] text-gray-400 py-12 px-6 font-montserrat text-sm border-t border-gray-900" data-id="element-76">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center gap-8" data-id="element-77">
          <div className="text-center md:text-left max-w-md" data-id="element-78">
            <h3 className="text-base font-bold mb-3" data-id="element-79">💅 BÓVEDA DIGITAL™</h3>
            <p className="mb-4" data-id="element-80">
              El sistema N°1 para profesionales de estética independientes en
              Argentina. Porque tener talento no alcanza. Necesitás un sistema.
            </p>
            <p className="italic text-brand" data-id="element-81">
              "El próximo lunes puede ser diferente." 💅
            </p>
          </div>

          <div className="flex flex-col gap-2 text-center md:text-right" data-id="element-82">
            <a href="mailto:soportebovedadigital@gmail.com" className="hover:text-base transition-colors" data-id="element-83">
              📧 soportebovedadigital@gmail.com
            </a>
            <a href="#" className="hover:text-base transition-colors" data-id="element-84">
              📱 @boveda.digital.ok
            </a>
            <a href="#" className="hover:text-base transition-colors" data-id="element-85">
              🌐 www.bovedadigital.online
            </a>
          </div>
        </div>

        <div className="max-w-6xl mx-auto mt-12 pt-8 border-t border-gray-800 text-center text-xs text-gray-500" data-id="element-86">
          <p data-id="element-87">
            © Bóveda Digital™ 2025 — Todos los derechos reservados. Prohibida
            la reproducción y redistribución sin autorización expresa.
          </p>
        </div>
      </footer>
    </>;
};